import{jsx as r}from"react/jsx-runtime";import{Stack as t}from"@fluentui/react";const e=e=>r(t,{horizontalAlign:"center",verticalAlign:"center",verticalFill:!0,...e});export{e as CenteredBox};
//# sourceMappingURL=CenteredBox.js.map
